// counterReducer.js

import * as actionType from '../actions/ActionType';

const cart = (state = {total: 0, items: []}, action) => {
  switch (action.type) {
    case actionType.ADDTOCART:

      let items = state.items;
      items.push(action.product);

      let newState = {
        total: state.total + (action.product.amount * action.product.price),
        items: items
      }
      return newState;
    case actionType.UPDATECART:

      let total = 0;
      action.products.forEach((item) => {total += item.price * item.amount});

      let newState2 = {
        total: total,
        items: action.products
      }
      return newState2;
    default:
      return state
  }
}

export default cart;



// WEBPACK FOOTER //
// ./src/reducers/cart.js